import type { SchemaBuilderDndWrapperProps } from "./schema-builder-dnd-wrapper.type";

import classNames from "classnames";

import "./schema-builder-dnd-wrapper.style.less";

export const SchemaBuilderDndWrapper = ({
  className,
  style,
  children,
}: SchemaBuilderDndWrapperProps) => {
  return (
    <div
      className={classNames("schema-builder-dnd-wrapper", className)}
      style={style}
    >
      {children}
    </div>
  );
};
